import { create } from 'zustand'

export interface SeismicWave {
  eventId: string
  lon: number
  lat: number
  /** 发震时刻（ms）。来源可信时为事件 originTime，否则为收到时刻 */
  originTs: number
  magnitude: number
  /** 后端 alert level（TAKE_ACTION / BE_AWARE），供全局警报状态机推导 */
  level?: string
}

interface WaveState {
  wave: SeismicWave | null
  /** 后到的预警覆盖先前的（取更新时间戳者） */
  startWave: (w: SeismicWave) => void
  stopWave: () => void
}

/**
 * P/S 波传播环动画状态：alert 推送到达即启动，传播出最大半径或手动停止后结束。
 */
export const useWaveStore = create<WaveState>((set) => ({
  wave: null,
  startWave: (w) => set((s) => ({ wave: s.wave && s.wave.originTs > w.originTs ? s.wave : w })),
  stopWave: () => set({ wave: null }),
}))
